import classNames from 'classnames';
import React from 'react';
import styles from "./alternate-headline.module.css";

/** React props interface for the AlternateHeadlines component. */

/**
 *
 * The AlternateHeadline component.
 * Used to render a title and possibly a subtitle, for use above discovery units.
 */
export const AlternateHeadline = ({
  className,
  layoutVariant = 'default',
  secondaryText,
  secondaryTextClass = 'ud-text-md',
  secondaryTextStyle = 'secondary-text',
  title,
  titleClass,
  titleId = '',
  titleStyle = 'title',
  titleTag = 'div'
}) => {
  let defaultTitleClass = 'ud-heading-xl';
  let headingStyle = styles[titleStyle];
  switch (layoutVariant) {
    case 'compact':
      defaultTitleClass = 'ud-heading-lg';
      headingStyle = styles['title-compact'];
      secondaryTextClass = 'ud-text-sm';
      break;
    case 'default':
      defaultTitleClass = 'ud-heading-xl';
      break;
    case 'large':
      defaultTitleClass = 'ud-heading-xxl';
      break;
  }
  titleClass = titleClass !== null && titleClass !== void 0 ? titleClass : defaultTitleClass;
  titleId = titleId !== '' ? titleId : title;
  const titleText = /*#__PURE__*/React.createElement(titleTag, {
    id: titleId,
    className: titleClass,
    'data-purpose': 'alternate-headline-title'
  }, title);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['title-container'], className)
  }, /*#__PURE__*/React.createElement("div", {
    className: headingStyle
  }, titleText), secondaryText && /*#__PURE__*/React.createElement("p", {
    className: classNames(secondaryTextClass, styles[secondaryTextStyle])
  }, secondaryText));
};
//# sourceMappingURL=alternate-headline.react-component.js.map